export interface FieldErrorProps {
    meta?: {
        error?: string;
        touched?: boolean;
        name?: string;
    };
}

export const SpotFieldError = (props: FieldErrorProps) => {
    const { meta } = props;
    return (
        <>
            {meta && meta.error && meta.touched && (
                <span className={`spot-form__field-error automation-field-error-${meta.name}`} role="alert">
                    <span className="spot-form__field-error-text"> {meta.error} </span>
                </span>
            )}
        </>
    );
};
